<template>
    <div class="options_filters_container">
        <div class="options_head">
            <div class="input_search">
                <label>
                    <div>
                        <input aria-label="Buscar variedad" placeholder="Buscar variedad" type="text" v-model="search">
                    </div>
                </label>
            </div>
            <span class="icon_search">
                <span>
                    <i class="fa fa-search"></i>
                </span>
            </span>
        </div>
        <div class="options_body">
            <div>
                <div class="contain">
                    <div class="options_item">
                        <div class="item">
                            <li v-for="item in items" @click="clickVariety(item.id)" :class="value===item.id?'check':''">
                                <span>
                                    {{ capitalize(item.especieName) }} {{ item.moteName.toLowerCase() }}
                                    <span style="text-transform: uppercase; font-weight: bold">{{item.name}}</span>
                                    <span v-if="item.isBpSeleccion && showMinOrder">
                                        <img src="/img/iconos/icon_bp_seleccion_custom.svg" alt="icon_bp_seleccion_custom.svg" class="icon bp-seleccion">
                                    </span>
                                    <span v-if="item.minOrder > 1 && showMinOrder" style="color: #c2282d; font-weight: bold">
                                        {{ item.minOrder }} Uds.
                                    </span>
                                </span>
                                <div class="c-more-info" @click="var_info_id=item.id">
                                    + info
                                </div>
                            </li>
                            <infinite-loading :distance="5000" :identifier="infiniteId" @infinite="loadVarieties"></infinite-loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <variety-info-modal :variedad_id.sync="var_info_id" :variedades="variedadesInfo"></variety-info-modal>
    </div>
</template>

<script>
    let cancelGetVarieties;

    export default {
        name: "VarietySelectList",
        props: {
            value: {},
            filterElements: {
                type: Object
            },
            showMinOrder: {
                type: Boolean,
                default: false
            },
            searchFilter: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                varieties: [],
                infiniteId: +new Date(),
                firstLoaded: false,
                page: 1,
                search: null,
                var_info_id: null,
            }
        },
        computed: {
            items() {
                return this.varieties.map(v => {
                    return {
                        id: v.id,
                        name: v.nombre,
                        moteName: v.mote.nombre,
                        especieName: v.mote.especie.nombre,
                        minOrder: v.min_order,
                        isBpSeleccion: v.is_bp_seleccion
                    }
                });
            },
            variedadesInfo() {
                return this.varieties.map(v => {
                    return {
                        id: v.id,
                        name: v.nombre,
                        moteName: v.mote.nombre,
                        especieName: v.mote.especie.nombre,
                        descripcion: v.descripcion,
                        rating: v.rating,
                        num_valoraciones: v.num_valoraciones
                    }
                });
            },
            filterParams() {
                return {
                    'especie_id': this.filterElements.especie,
                    'mote_id': this.filterElements.mote,
                    'search': this.search ? this.search : null,
                    'babyplant_seleccion': this.filterElements.babyplantSeleccion ? 1 : null,
                    'zona': this.filterElements.zona,
                    'zona_fria': this.filterElements.zonaFria ? 1 : null,
                    'zona_calida': this.filterElements.zonaCalida ? 1 : null,
                    'only_no_min_order': this.filterElements.onlyNoMinOrder ? 1 : null,
                    'main_variety_id': this.filterElements.mainVarietyId,
                    'injertable': this.filterElements.injertable ? 1 : null,
                    'only_with_price': this.filterElements.onlyWithPrice ? 1 : null
                };
            }
        },
        watch: {
            search(newVal, oldVal) {
                this.$emit('update:searchFilter', newVal);
                this.debouncedSearch();
            },
            filterParams: {
                deep: true,
                handler(newVal, oldVal) {
                    if (newVal.search === oldVal.search) {
                        this.resetInfiniteLoading();
                    }
                }
            },
            searchFilter(newVal) {
                this.search = newVal;
            }
        },
        methods: {
            clickVariety(varietyId) {
                this.$emit('input', varietyId);
                this.$emit('variety-data-changed', this.varieties.find(i => i.id === varietyId));
                let formData = new FormData();
                formData.append('variety_id', varietyId);
                axios.post(this.route("custom.variety-select-click"), formData);
            },
            resetInfiniteLoading() {
                this.page = 1;
                this.varieties = [];
                this.infiniteId += 1;
            },
            firstLoad() {
                if (!this.firstLoaded) {
                    this.resetInfiniteLoading();
                }
            },
            loadVarieties($state) {
                let vm = this;
                this.firstLoaded = true;
                if (cancelGetVarieties) {
                    cancelGetVarieties()
                }
                cancelGetVarieties = null;
                let params = vm.filterParams;
                params.page = vm.page;
                axios.get(vm.route("custom.variety-select-info"), {
                    params,
                    cancelToken: new axios.CancelToken(function executor(c) {
                        cancelGetVarieties = c;
                    })
                }).then((response) => {
                    let data = response.data;
                    let varieties = data.varieties;
                    if (varieties.length) {
                        vm.page += 1;
                        vm.varieties.push(...varieties);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                }).catch((err) => {
                    if (!error.status) {
                        Vue.toasted.error("Error al cargar los datos del servidor.", {
                            duration: 3000
                        });
                        vm.loadVarieties($state);
                    } else {
                        Vue.toasted.error("Error del servidor", {
                            duration: 3000
                        });
                        throw err;
                    }
                });
            },
            capitalize(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            }
        },
        created() {
            this.debouncedSearch = _.debounce(this.resetInfiniteLoading, 500);
            this.search = this.searchFilter;
        }
    }
</script>

<style scoped>
    .options_filters_container {
        border: 1px solid #ddd;
        /*box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);*/
        background: white;
        border-radius: 4px;
        z-index: 100;
        position: relative;
    }

    .options_filters_container .options_body {
        padding: 0 0 16px 16px;
        margin-top: 16px;
        color: #1a1a1a;
        transform: translateZ(0);
    }

    .options_filters_container .options_body .contain {
        overflow: auto;
        will-change: transform;
        height: 355px;
        width: 100%;
    }

    .options_filters_container .options_body .contain .options_item {
        position: relative;
        width: 100%;
        min-height: 100%;
        height: auto;
    }

    .options_filters_container .options_body .contain .options_item .item {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 40px;
    }

    .options_filters_container .options_body .contain .options_item .item li {
        text-transform: none;
        margin-bottom: 8px;
        margin-right: 16px;
        border: 1px solid #ddd;
        position: relative;
        display: flex;
        align-items: center;
        padding-top: 3px;
        padding-bottom: 3px;
        cursor: pointer;
        list-style-type: none;
        border-radius: 4px;
    }

    .options_filters_container .options_body .contain .options_item .item li > span {
        margin-left: 8px;
        margin-right: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
    }

    .options_filters_container .options_footer {
        display: flex;
        justify-content: flex-end;
        padding: 8px 16px;
        border-top: 1px solid #ddd;
    }

    .options_filters_container .options_footer .restart_button {
        background: white;
        text-align: right;
        margin-right: 8px;
        white-space: nowrap;
        height: 40px;
        padding: 0 12px;
        line-height: 40px;
        font-weight: 700;
        color: #1a1a1a;
    }

    .options_filters_container .options_body .contain .options_item .item li.check {
        border-color: black;
        background-color: #0871b8;
        color: white;
    }

    .options_filters_container .options_head {
        height: 36px;
        padding: 0 16px;
        margin-top: 16px;
        position: relative;
        display: flex;
        align-items: center;
        background: white;
    }

    .options_filters_container .options_head .input_search {
        background-color: white;
        border: 0;
        box-sizing: border-box;
        color: #1a1a1a;
        display: inline-block;
        position: relative;
        outline: 0;
        padding: 0;
        width: 100%;
        transition: box-shadow 0.25s;
        height: 100%;
        flex: 1;
    }

    .options_filters_container .options_head .input_search label {
        -webkit-tap-highlight-color: transparent;
        display: initial;
    }

    .options_filters_container .options_head .input_search label div {
        height: 100%;
    }

    .options_filters_container .options_head .input_search label div input {
        height: 100%;
        padding: 0 0 0 38px;
        font-size: 16px;
        box-shadow: none;
        color: #1a1a1a;
        border-radius: 4px;
        background: #f3f3f3;
        letter-spacing: 0.5px;
        box-sizing: border-box;
        display: block;
        line-height: 18px;
        margin: 0;
        outline: none;
        position: relative;
        vertical-align: baseline;
        width: 100%;
        -webkit-appearance: none;
        text-transform: none;
        border: 0;
        transition: box-shadow 0.25s ease;
    }

    .options_filters_container .options_head .icon_search {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }

    .options_filters_container .options_head .icon_search span {
        color: #1a1a1a;
        margin: -2px 0 -1px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        padding: 7px;
    }

    .options_filters_container .options_body .contain::-webkit-scrollbar {
        width: 8px;
    }

    .options_filters_container .options_body .contain::-webkit-scrollbar-thumb {
        background: #1a1a1a;
        border-radius: 8px;
    }

    .c-more-info {
        margin-left: auto;
        margin-right: 8px;
        white-space: nowrap;
        border: 1px solid;
        border-color: #0871b8;
        line-height: 1;
        padding: 3px;
        color: #0871b8;
        font-weight: 600;
    }

    .options_filters_container .options_body .contain .options_item .item li.check .c-more-info {
        border-color: white;
        color: white;
    }

    .icon {
        height: 1em;
    }

</style>
